import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Address } from 'clicklease-ui-elements';
import {
    PersonalInformationState,
    PersonalInformation,
    WritablePersonalInformation,
} from './../../interfaces';
import { PersonalInfoFeatureName } from './personal-information.reducer';

const getPersonalInformationState = (
    state: PersonalInformationState
): PersonalInformationState => state;

const getPersonalInformation = ({
    data,
}: PersonalInformationState): PersonalInformation => data;

const getPersonalWritableInformation = ({
    data,
}: PersonalInformationState): WritablePersonalInformation => ({
    address: data.address,
    firstName: data.firstName,
    lastName: data.lastName,
    phone: data.phone,
    email: data.email,
});

const getIsLoaded = ({ isLoaded }: PersonalInformationState): boolean =>
    isLoaded;

const getPersonalInformationFirstName = ({
    data,
}: PersonalInformationState): string => data.firstName;

const getPersonalInformationLastName = ({
    data,
}: PersonalInformationState): string => data.lastName;

const getPersonalInformationFullName = ({
    data,
}: PersonalInformationState): string => `${data.firstName} ${data.lastName}`;

const getPersonalInformationEmail = ({
    data,
}: PersonalInformationState): string => data.email;

const getPersonalInformationPhone = ({
    data,
}: PersonalInformationState): string => data.phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

const getPersonalInformationId = ({ data }: PersonalInformationState): string =>
    data.id;

const getPersonalInformationRoseId = ({
    data,
}: PersonalInformationState): string => data.roseId;

const getPersonalInformationAddress = ({
    data,
}: PersonalInformationState): Address => data.address;

const getPersonalInformationAddressLine1 = ({
    data,
}: PersonalInformationState): string => `${data.address.street},`;

const getPersonalInformationAddressLine2 = ({
    data,
}: PersonalInformationState): string => `${data.address.city}, ${data.address.state} ${data.address.zipcode}`;

export const PersonalInformationFeatureSelector =
    createFeatureSelector<PersonalInformationState>(
        PersonalInfoFeatureName
    );

export const PersonalInformationStateSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationState
);

export const PersonalInformationSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformation
);

export const PersonalWritableInformationSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalWritableInformation
);

export const PersonalInformationIsLoadedSelector = createSelector(
    PersonalInformationFeatureSelector,
    getIsLoaded
);

export const PersonalInformationFirstNameSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationFirstName
);

export const PersonalInformationFullNameSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationFullName
);

export const PersonalInformationIdSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationId
);

export const PersonalInformationRoseIdSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationRoseId
);

export const PersonalInformationAddressLine1Selector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationAddressLine1
);

export const PersonalInformationAddressLine2Selector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationAddressLine2
);

export const PersonalInformationLastNameSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationLastName
);

export const PersonalInformationEmailSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationEmail
);

export const PersonalInformationPhoneSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationPhone
);

export const PersonalInformationAddressSelector = createSelector(
    PersonalInformationFeatureSelector,
    getPersonalInformationAddress
);

export const PersonalInformationLastModifiedDateSelector = createSelector(
    PersonalInformationFeatureSelector,
    ({ data }: PersonalInformationState): string | null => data.lastModifiedDate
);
